import React from "react";
import SecondMainMenu from "../components/partials/header/second-main-menu";

const SecondHeader = () => {
  return (
    <header className="header header-6">
      <SecondMainMenu />
    </header>
  );
};

export default SecondHeader;
